import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { registerContentComponents } from '@skyeng/libs/shared/blocks/shared';
import { PythonExerciseComponent } from './component/python-exercise/python-exercise';
import { PythonTestCaseOutputComponent } from './component/python-test-case-output/python-test-case-output';
import { PythonTestCaseComponent } from './component/python-test-case/python-test-case';
import { PythonTestCaseInputComponent } from './component/python-test-case-input/python-test-case-input';
import { DsButtonModule } from '@skyeng/libs/shared/ui-kit-v2/button';
import { PythonCodeComponent } from './component/python-code-sample/python-code.component';
import { PythonBeforeCodeComponent } from './component/python-code-variables/python-before-code.component';
import { PythonAfterCodeComponent } from './component/python-code-end/python-after-code.component';
import { SkyI18nModule } from '@skyeng/libs/shared/i18n';
import { SkyUiSpinnerModule } from '@skyeng/libs/shared/ui-kit';
import { PythonResultMessageComponent } from './component/python-result-message/python-result-message.component';
import { TypografModule } from '@skyeng/libs/skypro/misc';
import { PythonExerciseTestCaseDescriptionComponent } from './component/python-exercise/test-case-description/python-exercise-test-case-description.component';
import { DsDialogModule } from '@skyeng/libs/shared/ui-kit-v2/dialog';
import { DsTooltipModule } from '@skyeng/libs/shared/ui-kit-v2/tooltip';
import { ResetDialogComponent } from './component/reset-dialog/reset-dialog.component';
import { CodeEditorComponent } from './component/code-editor/code-editor';
import { TranslocoModule } from '@ngneat/transloco';

const contentComponents = [
  PythonExerciseComponent,
  PythonTestCaseInputComponent,
  PythonTestCaseOutputComponent,
  PythonTestCaseComponent,
  PythonCodeComponent,
  PythonBeforeCodeComponent,
  PythonAfterCodeComponent,
  PythonResultMessageComponent,
];

@NgModule({
  declarations: [
    ...contentComponents,
    PythonExerciseTestCaseDescriptionComponent,
    ResetDialogComponent,
    CodeEditorComponent,
  ],
  imports: [
    CommonModule,
    DsButtonModule,
    DsDialogModule,
    DsTooltipModule,
    SkyI18nModule,
    SkyUiSpinnerModule,
    TypografModule,
    TranslocoModule,
  ],
  exports: [...contentComponents],
  providers: [registerContentComponents(contentComponents)],
})
export class SkyproBlocksPythonExerciseModule {}
